import { type SVGProps } from "react";
import styled from "styled-components";

type Props = SVGProps<SVGSVGElement>;

const SvgIconBase = styled.svg`
    width: fit-content;
    height: 1em;

    display: inline-block;
    align-items: center;

    font-size: inherit;

    fill: currentcolor;
`;

export { SvgIconBase };
export type { Props as SvgIconBaseProps };
